import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  data: {},
};

const syncReducers = {
  setCountry: (state, { payload }) => {
    return { ...state, data: { ...payload } };
  },
};

const store = createSlice({
  name: "country",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { setCountry } = store.actions;

export default store.reducer;
